import React from 'react'
import StripeFormAndDetails from '../../../components/stripeFormAndDetails/StripeFormAndDetails'

const checkout = () => {
  return (
    <>
        <StripeFormAndDetails />
    </>
  )
}

export default checkout